export default "__VITE_ASSET__CTQQeevY__"